/**
 * @generated SignedSource<<a447015bc949c4fba67e6d85e118f879>>
 * @relayHash 4080d0348429819fb6dfee205f8546af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6e5c3406f3aa71a5cc466412df75b93545372ce9a907236748b6d9be75b83a7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionIssuesSortField = "ASSIGNEE" | "CREATED" | "KEY" | "PRIORITY" | "STATUS" | "TYPE" | "%future added value";
export type JiraVersionIssuesStatusCategories = "DONE" | "IN_PROGRESS" | "TODO" | "%future added value";
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type JiraVersionWarningCategories = "FAILING_BUILD" | "OPEN_PULL_REQUEST" | "OPEN_REVIEW" | "UNREVIEWED_CODE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionIssuesSortInput = {
  order?: SortDirection | null | undefined;
  sortByField?: JiraVersionIssuesSortField | null | undefined;
};
export type JiraVersionIssuesFiltersInput = {
  assigneeAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  epicIds?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
  statusCategories?: ReadonlyArray<JiraVersionIssuesStatusCategories> | null | undefined;
  warningCategories?: ReadonlyArray<JiraVersionWarningCategories> | null | undefined;
};
export type uiVersionDetailsQuery$variables = {
  cloudAri: string;
  filters?: JiraVersionIssuesFiltersInput | null | undefined;
  isDevopsFeatureDisabledInFedRamp: boolean;
  shouldIncludeDevOpsFieldsViaAgs: boolean;
  skip: boolean;
  sortBy?: JiraVersionIssuesSortInput | null | undefined;
  versionAri: string;
};
export type uiVersionDetailsQuery$data = {
  readonly devOps: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetail_VersionDetailInner_devOps">;
  } | null | undefined;
  readonly jira?: {
    readonly version: {
      readonly __typename: "JiraVersion";
      readonly __typename: "JiraVersion";
      readonly name: string | null | undefined;
      readonly status: JiraVersionStatus | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"accessCheck_softwareReleasesVersionDetail" | "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type uiVersionDetailsQuery = {
  response: uiVersionDetailsQuery$data;
  variables: uiVersionDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeDevOpsFieldsViaAgs"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionAri"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "status"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "ScalarField",
  "name": "collapsedUis"
},
v13 = {
  "kind": "Literal",
  "name": "filter",
  "value": "ALL"
},
v14 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v19 = {
  "kind": "ScalarField",
  "name": "picture"
},
v20 = {
  "kind": "ScalarField",
  "name": "description"
},
v21 = [
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v22 = {
  "kind": "ScalarField",
  "name": "count"
},
v23 = {
  "kind": "ScalarField",
  "name": "state"
},
v24 = {
  "concreteType": "DevOpsSummarisedBuildState",
  "kind": "LinkedField",
  "name": "buildStates",
  "plural": true,
  "selections": [
    (v23/*: any*/),
    (v22/*: any*/)
  ]
},
v25 = [
  (v22/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "name": "title"
},
v27 = [
  (v22/*: any*/),
  (v11/*: any*/)
],
v28 = {
  "concreteType": "DevOpsSummarisedDeployments",
  "kind": "LinkedField",
  "name": "summarisedDeployments",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v30 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v32 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiVersionDetailsQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps"
          }
        ]
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraQuery",
              "kind": "LinkedField",
              "name": "jira",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v7/*: any*/),
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "accessCheck_softwareReleasesVersionDetail"
                          }
                        ],
                        "type": "JiraVersion"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.version"
                }
              ]
            },
            "action": "THROW",
            "path": "jira"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiVersionDetailsQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "cloudAri"
                  },
                  {
                    "kind": "Literal",
                    "name": "providerTypes",
                    "value": [
                      "DESIGN"
                    ]
                  }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "DevOpsDesignProvider",
                    "kind": "LinkedField",
                    "name": "designProviders",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v7/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "canAddAndRemoveIssues"
                      },
                      (v12/*: any*/),
                      {
                        "alias": "allIssues",
                        "args": [
                          (v13/*: any*/)
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": "issues(filter:\"ALL\")"
                      },
                      (v16/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "startDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "releaseDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "versionId"
                      },
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cloudId"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "maxHierarchyLevel": 1,
                                  "minHierarchyLevel": 1
                                }
                              }
                            ],
                            "concreteType": "JiraIssueTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v11/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectStyle"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraVersionDriverResult",
                        "kind": "LinkedField",
                        "name": "driverData",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "driver",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v18/*: any*/),
                              (v9/*: any*/),
                              (v19/*: any*/),
                              (v11/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "queryError",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "message"
                              }
                            ]
                          }
                        ]
                      },
                      (v20/*: any*/),
                      {
                        "concreteType": "JiraVersionWarningConfig",
                        "kind": "LinkedField",
                        "name": "warningConfig",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "openPullRequest"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "openReview"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "unreviewedCode"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "failingBuild"
                          },
                          (v16/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraVersionConnectAddonIframeData",
                        "kind": "LinkedField",
                        "name": "connectAddonIframeData",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "appKey"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "appName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "location"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "options"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canViewDevTools"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "versionIssueTableHiddenColumns"
                      },
                      {
                        "alias": "issuesForList",
                        "args": (v21/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jql"
                          },
                          {
                            "concreteType": "JiraIssueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                          "priority",
                                          "summary",
                                          "assignee",
                                          "status",
                                          "issuetype"
                                        ]
                                      }
                                    ],
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraStatusCategory",
                                                        "kind": "LinkedField",
                                                        "name": "statusCategory",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "statusCategoryId"
                                                          },
                                                          (v11/*: any*/)
                                                        ]
                                                      },
                                                      (v11/*: any*/),
                                                      (v9/*: any*/),
                                                      (v20/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusField"
                                              },
                                              (v11/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v8/*: any*/),
                                                      (v19/*: any*/),
                                                      (v9/*: any*/),
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraSingleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "text"
                                                  }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "xsmall"
                                                          }
                                                        ]
                                                      },
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconUrl"
                                                      },
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraPriorityField"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueId"
                                  },
                                  {
                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                    "kind": "LinkedField",
                                    "name": "summarisedFeatureFlags",
                                    "plural": false,
                                    "selections": (v15/*: any*/)
                                  },
                                  (v8/*: any*/),
                                  {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "concreteType": "DevOpsSummarisedEntities",
                                        "kind": "LinkedField",
                                        "name": "devOpsSummarisedEntities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "DevOpsSummarisedDeployments",
                                            "kind": "LinkedField",
                                            "name": "summarisedDeployments",
                                            "plural": false,
                                            "selections": [
                                              (v22/*: any*/),
                                              (v11/*: any*/),
                                              {
                                                "concreteType": "DevOpsEnvironment",
                                                "kind": "LinkedField",
                                                "name": "deploymentEnvironment",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "deploymentState"
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "DevOpsSummarisedBuilds",
                                            "kind": "LinkedField",
                                            "name": "summarisedBuilds",
                                            "plural": false,
                                            "selections": [
                                              (v22/*: any*/),
                                              (v11/*: any*/),
                                              (v24/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueDevSummaryResult",
                                        "kind": "LinkedField",
                                        "name": "devSummaryCache",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueDevSummary",
                                            "kind": "LinkedField",
                                            "name": "devSummary",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      (v22/*: any*/),
                                                      (v23/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "branch",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": (v25/*: any*/)
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "review",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      (v22/*: any*/),
                                                      (v23/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "lastUpdated"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "stateCount"
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                    "kind": "LinkedField",
                                                    "name": "summaryByProvider",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "providerId"
                                                      },
                                                      (v9/*: any*/),
                                                      (v22/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": (v25/*: any*/)
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      (v22/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "failedBuildCount"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "successfulBuildCount"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "unknownBuildCount"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "deploymentEnvironments",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                                        "kind": "LinkedField",
                                                        "name": "topEnvironments",
                                                        "plural": true,
                                                        "selections": [
                                                          (v10/*: any*/),
                                                          (v26/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "DevOpsSummarisedFeatureFlags",
                                        "kind": "LinkedField",
                                        "name": "summarisedFeatureFlags",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "mostRelevantDisplayName"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "mostRelevantEnabled"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "mostRelevantRolloutPercentage"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          (v28/*: any*/),
                                          {
                                            "concreteType": "DevOpsSummarisedBuilds",
                                            "kind": "LinkedField",
                                            "name": "summarisedBuilds",
                                            "plural": false,
                                            "selections": [
                                              (v24/*: any*/),
                                              (v22/*: any*/),
                                              (v11/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      (v28/*: any*/),
                                      {
                                        "concreteType": "DevOpsSummarisedBuilds",
                                        "kind": "LinkedField",
                                        "name": "summarisedBuilds",
                                        "plural": false,
                                        "selections": (v27/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v29/*: any*/)
                            ]
                          },
                          (v30/*: any*/)
                        ]
                      },
                      {
                        "alias": "issuesForList",
                        "args": (v21/*: any*/),
                        "filters": [
                          "filter",
                          "sortBy",
                          "filters"
                        ],
                        "handle": "connection",
                        "key": "ListVersion_issuesForList",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      },
                      {
                        "alias": "allIssuesRedesignTemp",
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      (v12/*: any*/),
                      {
                        "args": (v31/*: any*/),
                        "concreteType": "JiraVersionApproverConnection",
                        "kind": "LinkedField",
                        "name": "approvers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraVersionApproverEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraVersionApprover",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                            "kind": "LinkedField",
                                            "name": "extendedProfile",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "jobTitle"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "AtlassianAccountUser"
                                      },
                                      (v11/*: any*/),
                                      (v18/*: any*/)
                                    ]
                                  },
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "declineReason"
                                  },
                                  (v20/*: any*/),
                                  (v32/*: any*/),
                                  (v8/*: any*/)
                                ]
                              },
                              (v29/*: any*/)
                            ]
                          },
                          (v30/*: any*/)
                        ],
                        "storageKey": "approvers(first:100)"
                      },
                      {
                        "args": (v31/*: any*/),
                        "handle": "connection",
                        "key": "version_approvers",
                        "kind": "LinkedHandle",
                        "name": "approvers"
                      },
                      {
                        "concreteType": "JiraVersionRichTextSection",
                        "kind": "LinkedField",
                        "name": "richTextSection",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "json"
                              }
                            ]
                          },
                          (v26/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canViewVersionDetailsPage"
                      },
                      {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsSummarisedEntities",
                            "kind": "LinkedField",
                            "name": "devOpsSummarisedEntities",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "DevOpsFeatureFlagProvider",
                                    "kind": "LinkedField",
                                    "name": "featureFlagProviders",
                                    "plural": true,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v11/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "createFeatureFlagTemplateUrl"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "connectFeatureFlagTemplateUrl"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "logoUrl"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v32/*: any*/)
                    ],
                    "type": "JiraVersion"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b6e5c3406f3aa71a5cc466412df75b93545372ce9a907236748b6d9be75b83a7",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ecff0899e38f1db871d5c88fd51da16f";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
